import type FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import getFocusedViewFilter from 'mini-mail-list-store/lib/utils/getFocusedViewFilter';
import isFocusedInboxEnabled from 'mini-mail-focused-inbox-config/lib/isFocusedInboxEnabled';
import { getNativeAdShowStatus, type NativeAdUserFlight } from 'mini-mail-nativead-userchecker';
import { isMiniFeatureEnabled } from 'owa-mini-feature-flags';
import { isMiniHostAppFeatureEnabled } from 'mini-hostapp-feature-flags/lib/isMiniHostAppFeatureEnabled';

export const getIsShowMultipleAds = () =>
    isMiniHostAppFeatureEnabled('multipleAds') &&
    getNativeAdShowStatus() === 1 &&
    ((isFocusedInboxEnabled() &&
        (isMiniFeatureEnabled('miniAE-MultipleAdInOther-3rdPosition-treatment') ||
            isMiniFeatureEnabled('miniAE-MultipleAdInOther-4thPosition-treatment') ||
            isMiniFeatureEnabled('miniAE-MultipleAdInOther-5thPosition-treatment')) &&
        getFocusedViewFilter() !== 0) ||
        (!isFocusedInboxEnabled() &&
            (isMiniFeatureEnabled('miniAE-MultipleAdInPrimary-3rdPosition-treatment') ||
                isMiniFeatureEnabled('miniAE-MultipleAdInPrimary-4thPosition-treatment') ||
                isMiniFeatureEnabled('miniAE-MultipleAdInPrimary-5thPosition-treatment'))));
